<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.origemProgramatica"
        ref="RkmDataTable"
        sort-by="nome"
    >
        <template v-slot:cell(actions)="row">
            <rkm-button
                @click="handleEdit(row.item.id)"
                authorize="update-cadastro-origem-programatica"
                color="primary"
                small
                title="Editar"
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                @click.stop="handleDestroy(row.item.id)"
                authorize="destroy-cadastro-origem-programatica"
                color="danger"
                small
                title="Excluir"
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import {error, repository} from '@/mixins'

export default {
    computed: {
        fields() {
            return [
                {key: 'nome', label: 'Nome', name: 'cadastroOrigemProgramatica.nome', searchable: true, sortable: true},
                {key: 'programaTipoNome', label: 'Tipo de programa', name: 'cadastroOrigemProgramaticaProgramaTipo.nome', searchable: true, sortable: true},
                {key: 'fornecimentoTipoNome', label: 'Tipo de fornecimento', name: 'cadastroOrigemProgramaticaFornecimentoTipo.nome', searchable: true, sortable: true},
                {key: 'estruturaApoioNome', label: 'Estrutura de apoio', name: 'cadastroOrigemProgramaticaEstruturaApoio.nome', searchable: true, sortable: true},
                {key: 'ativo', label: 'Ativo', name: 'cadastroOrigemProgramatica.ativo', searchable: true, sortable: true},
                {class: 'col-min text-center', key: 'actions', label: 'Ações'},
            ]
        },
    },
    created() {
        this.repositories = {
            origemProgramatica: this.getConectaSusRepository('cadastro.origemProgramatica')
        }
    },
    methods: {
        handleEdit(id) {
            this.$router.push({name: 'cadastro-origem-programatica-edit', params: {id: id}})
        },
        handleDestroy(id) {
            const destroy = () => this.repositories.origemProgramatica.destroy(id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir a origem programática?', destroy, this.handleError)
        },
    },
    mixins: [error, repository],
}
</script>